"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2900],{

/***/ 72557:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "_I": function() { return /* binding */ AuthSectionType; },
  "ZP": function() { return /* binding */ components_AuthSection; },
  "XH": function() { return /* binding */ useAuthSubmitHandlers; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(10092);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./components/ui/card.tsx
var card = __webpack_require__(64345);
// EXTERNAL MODULE: ./components/ui/button.tsx
var ui_button = __webpack_require__(35739);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./util/util.ts + 4 modules
var util = __webpack_require__(94811);
// EXTERNAL MODULE: ./util/auth.tsx + 1 modules
var util_auth = __webpack_require__(19475);
// EXTERNAL MODULE: ./util/hooks/useAssessmentFormStorage.ts
var useAssessmentFormStorage = __webpack_require__(38625);
// EXTERNAL MODULE: ./node_modules/react-google-recaptcha-v3/dist/react-google-recaptcha-v3.esm.js
var react_google_recaptcha_v3_esm = __webpack_require__(50259);
// EXTERNAL MODULE: ./util/gmt.js
var gmt = __webpack_require__(74802);
// EXTERNAL MODULE: ./util/timezone.js
var timezone = __webpack_require__(55870);
// EXTERNAL MODULE: ./components/ui/input.tsx
var input = __webpack_require__(72685);
// EXTERNAL MODULE: ./node_modules/zod/lib/index.mjs
var lib = __webpack_require__(1604);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./node_modules/@hookform/resolvers/zod/dist/zod.mjs + 1 modules
var zod = __webpack_require__(56312);
// EXTERNAL MODULE: ./components/ui/form.tsx
var ui_form = __webpack_require__(27946);
;// CONCATENATED MODULE: ./components/forms/SignInForm.tsx










var formSchema = lib/* object */.Ry({
    email: lib/* string */.Z_({
        required_error: "Please enter an email"
    }).min(1, {
        message: "This field has to be filled."
    }).email("This is not a valid email."),
    password: lib/* string */.Z_({
        required_error: "You must specify a password"
    }).min(8, {
        message: "Password must have at least 8 characters"
    })
});
formSchema.required({
    email: true,
    password: true
});
var SignInForm = function(props) {
    var form = (0,index_esm/* useForm */.cI)({
        resolver: (0,zod/* zodResolver */.F)(formSchema)
    });
    var onSubmit = function(values) {
        if (typeof props.onSubmit === "function") {
            props.onSubmit(values);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_form/* Form */.l0, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, form), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                    onSubmit: form.handleSubmit(onSubmit),
                    className: "space-y-4",
                    id: props.formId,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_form/* FormField */.Wi, {
                            control: form.control,
                            name: "email",
                            render: function(param) {
                                var field = param.field;
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui_form/* FormItem */.xJ, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_form/* FormLabel */.lX, {
                                            children: "Email"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_form/* FormControl */.NI, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* Input */.I, (0,_object_spread/* default */.Z)({}, field))
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_form/* FormMessage */.zG, {})
                                    ]
                                });
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_form/* FormField */.Wi, {
                            control: form.control,
                            name: "password",
                            render: function(param) {
                                var field = param.field;
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui_form/* FormItem */.xJ, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_form/* FormLabel */.lX, {
                                            children: "Password"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_form/* FormControl */.NI, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* Input */.I, (0,_object_spread/* default */.Z)({
                                                type: "password"
                                            }, field))
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_form/* FormMessage */.zG, {})
                                    ]
                                });
                            }
                        })
                    ]
                })
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: "/passforgotten",
                    passHref: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        className: "text-sm underline-offset-4 hover:underline text-primary",
                        children: "Forgot password"
                    })
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./components/Recaptcha.tsx
var Recaptcha = __webpack_require__(70822);
;// CONCATENATED MODULE: ./components/forms/PasswordForgotForm.tsx









var PasswordForgotForm_formSchema = lib/* object */.Ry({
    email: lib/* string */.Z_({
        required_error: "Please enter an email"
    }).min(1, {
        message: "This field has to be filled."
    }).email("This is not a valid email.")
});
PasswordForgotForm_formSchema.required({
    email: true
});
var PasswordForgotForm = function(props) {
    var form = (0,index_esm/* useForm */.cI)({
        resolver: (0,zod/* zodResolver */.F)(PasswordForgotForm_formSchema)
    });
    var onSubmit = function(values) {
        if (typeof props.onSubmit === "function") {
            props.onSubmit(values);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_form/* Form */.l0, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, form), {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
                onSubmit: form.handleSubmit(onSubmit),
                className: "space-y-4",
                id: props.formId,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_form/* FormField */.Wi, {
                    control: form.control,
                    name: "email",
                    render: function(param) {
                        var field = param.field;
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui_form/* FormItem */.xJ, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_form/* FormLabel */.lX, {
                                    children: "Email"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_form/* FormControl */.NI, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* Input */.I, (0,_object_spread/* default */.Z)({}, field))
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_form/* FormMessage */.zG, {})
                            ]
                        });
                    }
                })
            })
        }))
    });
};

;// CONCATENATED MODULE: ./components/forms/PasswordResetForm.tsx









var PasswordResetForm_formSchema = lib/* object */.Ry({
    password: lib/* string */.Z_({
        required_error: "You must specify a password"
    }).min(8, {
        message: "Password must have at least 8 characters"
    }),
    confirmPassword: lib/* string */.Z_({
        required_error: "You must specify a password"
    }).min(8, {
        message: "Password must have at least 8 characters"
    })
}).refine(function(data) {
    return data.password === data.confirmPassword;
}, {
    message: "Passwords don't match",
    path: [
        "confirmPassword"
    ]
});
var PasswordResetForm = function(props) {
    var form = (0,index_esm/* useForm */.cI)({
        resolver: (0,zod/* zodResolver */.F)(PasswordResetForm_formSchema)
    });
    var onSubmit = function(values) {
        if (typeof props.onSubmit === "function") {
            props.onSubmit({
                password: values.password,
                confirmPassword: values.confirmPassword
            });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_form/* Form */.l0, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, form), {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                onSubmit: form.handleSubmit(onSubmit),
                className: "space-y-4",
                id: props.formId,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_form/* FormField */.Wi, {
                        control: form.control,
                        name: "password",
                        render: function(param) {
                            var field = param.field;
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui_form/* FormItem */.xJ, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_form/* FormLabel */.lX, {
                                        children: "New password"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_form/* FormControl */.NI, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* Input */.I, (0,_object_spread/* default */.Z)({
                                            type: "password",
                                            autoComplete: "new-password"
                                        }, field))
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_form/* FormMessage */.zG, {})
                                ]
                            });
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_form/* FormField */.Wi, {
                        control: form.control,
                        name: "confirmPassword",
                        render: function(param) {
                            var field = param.field;
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui_form/* FormItem */.xJ, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_form/* FormLabel */.lX, {
                                        children: "Repeat password"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_form/* FormControl */.NI, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* Input */.I, (0,_object_spread/* default */.Z)({
                                            type: "password",
                                            autoComplete: "new-password"
                                        }, field))
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_form/* FormMessage */.zG, {})
                                ]
                            });
                        }
                    })
                ]
            })
        }))
    });
};

// EXTERNAL MODULE: ./components/forms/SignUpForm.tsx
var SignUpForm = __webpack_require__(5138);
// EXTERNAL MODULE: ./components/CodeOfConductModal.tsx
var CodeOfConductModal = __webpack_require__(83642);
// EXTERNAL MODULE: ./components/ui/typography.tsx
var typography = __webpack_require__(58020);
// EXTERNAL MODULE: ./lib/utils.ts + 11 modules
var utils = __webpack_require__(74183);
;// CONCATENATED MODULE: ./components/AuthSection.tsx

























var AuthSectionType;
(function(AuthSectionType) {
    AuthSectionType["SignIn"] = "signin";
    AuthSectionType["SignUp"] = "signup";
    AuthSectionType["ForgotPassword"] = "forgotpass";
    AuthSectionType["ResetPassword"] = "resetpass";
})(AuthSectionType || (AuthSectionType = {}));
var useAuthSubmitHandlers = function(param) {
    var afterAuthPath = param.afterAuthPath, onError = param.onError, type = param.type;
    var router = (0,next_router.useRouter)();
    var ref = (0,_sliced_to_array/* default */.Z)((0,useAssessmentFormStorage/* useAssessmentFormStorage */.G)(), 1), answers = ref[0];
    var handleAuth = function() {
        router.push((0,util/* forceInternalPath */.Kl)(afterAuthPath));
    };
    var auth = (0,util_auth/* useAuth */.aC)();
    var executeRecaptcha = (0,react_google_recaptcha_v3_esm/* useGoogleReCaptcha */.xX)().executeRecaptcha;
    var submitHandlersByType = {
        signin: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!("password" in data) || !("email" in data)) {
                                return [
                                    2
                                ];
                            }
                            return [
                                4,
                                auth.signin({
                                    username: data.email,
                                    password: data.password,
                                    recaptchaToken: data.recaptchaToken
                                }).then(function(user) {
                                    (0,gmt/* addGtmEvent */.x)(gmt/* events.login */.U.login, {
                                        authenticationMethod: "email",
                                        userId: user.id
                                    });
                                    handleAuth();
                                })
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            });
            return function(data) {
                return _ref.apply(this, arguments);
            };
        }(),
        signup: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
                var selfAssessmentResults;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!("password" in data) || !("email" in data)) {
                                return [
                                    2
                                ];
                            }
                            if (answers) {
                                selfAssessmentResults = Object.values(answers).filter(Boolean);
                            }
                            return [
                                4,
                                auth.signup((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                    timezone: (0,timezone/* getDefaultTimezone */.PU)()
                                }, data), {
                                    codeOfConduct: true,
                                    terms: true,
                                    keepPrivate: true,
                                    assessmentData: selfAssessmentResults || undefined
                                })).then(function() {
                                    var email = data.email;
                                    if (email) {
                                        (0,gmt/* addGtmEvent */.x)(gmt/* events.registration */.U.registration, {
                                            authenticationMethod: "email"
                                        });
                                        router.replace("/verify?email=".concat(encodeURIComponent(email)));
                                    }
                                })
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            });
            return function(data) {
                return _ref.apply(this, arguments);
            };
        }(),
        forgotpass: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!("email" in data)) {
                                return [
                                    2
                                ];
                            }
                            return [
                                4,
                                auth.forgotpass((0,_object_spread/* default */.Z)({}, data)).then(function(response) {
                                    var email = data.email;
                                    if (email && response.status === "SUCCESS") {
                                        router.replace("/passforgotten?email=".concat(encodeURIComponent(email)), undefined, {
                                            shallow: true
                                        });
                                    }
                                })
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            });
            return function(data) {
                return _ref.apply(this, arguments);
            };
        }(),
        resetpass: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
                var hash;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!("password" in data) || !("confirmPassword" in data)) {
                                return [
                                    2
                                ];
                            }
                            hash = router.query.hash;
                            return [
                                4,
                                auth.resetpass({
                                    hash: hash,
                                    new_password1: data.password,
                                    new_password2: data.confirmPassword,
                                    recaptcha_token: data.recaptchaToken
                                }).then(function(response) {
                                    if (response.status === "SAVED") {
                                        router.replace("/");
                                    }
                                })
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            });
            return function(data) {
                return _ref.apply(this, arguments);
            };
        }()
    };
    // typ should be key of submitHandlersByType
    return function(formData) {
        if (!executeRecaptcha) {
            return;
        }
        executeRecaptcha(type).then(function(token) {
            return submitHandlersByType[type]((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formData), {
                recaptchaToken: token
            })).catch(onError);
        });
    };
};
function AuthSection(props) {
    var ref = (0,react.useState)(null), formAlert = ref[0], setFormAlert = ref[1];
    var handleFormAlert = function(data) {
        setFormAlert(data);
    };
    var ref1 = (0,react.useState)(false), isCodeOfConductModalOpen = ref1[0], setIsCodeOfConductModalOpen = ref1[1];
    var onSubmit = useAuthSubmitHandlers({
        afterAuthPath: props.afterAuthPath,
        onError: handleFormAlert,
        type: props.type
    });
    var formId = "form_".concat(props.type);
    var allTypeValues = {
        signin: {
            title: "Welcome!",
            subtitleText: "Don't have and account yet?",
            subtitleLink: "/auth/signup",
            subtitleLinkText: "Sign up",
            buttonText: "Log in"
        },
        signup: {
            title: "Try Casehub free for 14 days!",
            buttonText: "Create an account",
            subtitleText: "Full access. No credit cards required."
        },
        forgotpass: {
            title: "Reset password",
            buttonText: "Reset"
        },
        resetpass: {
            title: "Update password",
            buttonText: "Submit"
        }
    };
    var currentType = props.type;
    var typeValues = allTypeValues[currentType];
    if (!typeValues) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "container",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "flex items-center justify-center py-12",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(card/* Card */.Zb, {
                className: "w-full max-w-screen sm:w-1/2 lg:w-1/3",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(card/* CardHeader */.Ol, {
                        className: "space-y-1",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(card/* CardTitle */.ll, {
                                className: "text-2xl",
                                children: typeValues.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(card/* CardDescription */.SZ, {
                                children: [
                                    typeValues.subtitleText,
                                    " ",
                                    typeValues.subtitleLink ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: typeValues.subtitleLink,
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_button/* Button */.z, {
                                            asChild: true,
                                            variant: "link",
                                            className: "p-0",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                children: typeValues.subtitleLinkText
                                            })
                                        })
                                    }) : null
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(card/* CardContent */.aY, {
                        className: "grid gap-4",
                        children: [
                            props.type === AuthSectionType.SignIn && /*#__PURE__*/ (0,jsx_runtime.jsx)(SignInForm, {
                                onSubmit: onSubmit,
                                formId: formId
                            }),
                            props.type === AuthSectionType.SignUp && /*#__PURE__*/ (0,jsx_runtime.jsx)(SignUpForm/* SignUpForm */.W, {
                                onSubmit: onSubmit,
                                formId: formId
                            }),
                            props.type === AuthSectionType.ForgotPassword && /*#__PURE__*/ (0,jsx_runtime.jsx)(PasswordForgotForm, {
                                onSubmit: onSubmit,
                                formId: formId
                            }),
                            props.type === AuthSectionType.ResetPassword && /*#__PURE__*/ (0,jsx_runtime.jsx)(PasswordResetForm, {
                                onSubmit: onSubmit,
                                formId: formId
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(card/* CardFooter */.eW, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col gap-2 w-full",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_button/* Button */.z, {
                                    type: "submit",
                                    className: "w-full",
                                    form: formId,
                                    children: typeValues.buttonText
                                }),
                                !!(formAlert === null || formAlert === void 0 ? void 0 : formAlert.message) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "text-sm font-semibold leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70 text-destructive",
                                        children: formAlert.message
                                    })
                                }),
                                props.type === AuthSectionType.SignUp ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "w-full mt-8 text-center grid gap-2",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                                            variant: "muted",
                                            asChild: true,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                children: [
                                                    "By signing up, you accept our",
                                                    " ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                        href: "/content/terms",
                                                        passHref: true,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            className: (0,utils.cn)((0,ui_button/* buttonVariants */.d)({
                                                                variant: "link"
                                                            }), "p-0 h-auto"),
                                                            target: "_blank",
                                                            rel: "nofollow noopener",
                                                            children: "Terms of use"
                                                        })
                                                    }),
                                                    " ",
                                                    "and",
                                                    " ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_button/* Button */.z, {
                                                        variant: "link",
                                                        className: "p-0 h-auto",
                                                        onClick: function() {
                                                            setIsCodeOfConductModalOpen(true);
                                                        },
                                                        children: "Code of Conduct"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(typography/* Typography */.Z, {
                                            variant: "muted",
                                            children: [
                                                "Already have an account?",
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: "/auth/signin",
                                                    passHref: true,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        className: (0,utils.cn)((0,ui_button/* buttonVariants */.d)({
                                                            variant: "link"
                                                        }), "p-0 inline"),
                                                        target: "_blank",
                                                        rel: "nofollow noopener",
                                                        children: "Log in."
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CodeOfConductModal/* default */.Z, {
                                            open: isCodeOfConductModalOpen,
                                            onOpenChange: setIsCodeOfConductModalOpen
                                        })
                                    ]
                                }) : null
                            ]
                        })
                    })
                ]
            })
        })
    });
}
/* harmony default export */ var components_AuthSection = ((0,Recaptcha/* RecaptchaComponent */.w)(AuthSection));


/***/ }),

/***/ 83642:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_ui_typography__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(58020);
/* harmony import */ var _components_ui_dialog__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70499);
/* harmony import */ var _components_ui_button__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(35739);
/* harmony import */ var _components_ui_scroll_area__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(92447);






var CodeOfConductModal = function(props) {
    var onOpenChange = props.onOpenChange, open = props.open;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_dialog__WEBPACK_IMPORTED_MODULE_3__/* .Dialog */ .Vq, {
        open: open,
        onOpenChange: onOpenChange,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_ui_dialog__WEBPACK_IMPORTED_MODULE_3__/* .DialogContent */ .cZ, {
            className: "w-full max-w-screen sm:max-w-screen-lg sm:w-2/3 lg:w-1/2",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_dialog__WEBPACK_IMPORTED_MODULE_3__/* .DialogHeader */ .fK, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_dialog__WEBPACK_IMPORTED_MODULE_3__/* .DialogTitle */ .$N, {
                        children: "As a member of Casehub"
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_scroll_area__WEBPACK_IMPORTED_MODULE_5__/* .ScrollArea */ .x, {
                    className: "max-h-[80vh]",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "grid gap-4 py-4",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(CodeOfConductSection, {
                                    title: "Communication",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_ui_typography__WEBPACK_IMPORTED_MODULE_2__/* .Typography */ .Z, {
                                            variant: "p",
                                            children: [
                                                "In all my oral or written communication",
                                                " ",
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                                    children: "I respect"
                                                }),
                                                " ",
                                                "other Casehub Members."
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_ui_typography__WEBPACK_IMPORTED_MODULE_2__/* .Typography */ .Z, {
                                            variant: "p",
                                            children: [
                                                "As a sign of respect to other Members, I will",
                                                " ",
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                                    children: "fill my Casehub profile"
                                                }),
                                                " ",
                                                "and upload my Photo."
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(CodeOfConductSection, {
                                    title: "Sessions",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_ui_typography__WEBPACK_IMPORTED_MODULE_2__/* .Typography */ .Z, {
                                            variant: "p",
                                            children: [
                                                "When participating in Casehub’s live group sessions (listed in “Schedule” section of the Site)",
                                                " ",
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                                    children: "I keep any specific person or organisation related information shared by other participants confidential."
                                                }),
                                                " ",
                                                "I can share the ideas, suggestions, or conclusions from the session only without revealing the identity of the person or related organisation."
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_ui_typography__WEBPACK_IMPORTED_MODULE_2__/* .Typography */ .Z, {
                                            variant: "p",
                                            children: [
                                                "I give Casehub my",
                                                " ",
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                                    children: "permission to record the sessions"
                                                }),
                                                " ",
                                                "where I participate, cut and edit the videos and post them on the Casehub website."
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_ui_typography__WEBPACK_IMPORTED_MODULE_2__/* .Typography */ .Z, {
                                            variant: "p",
                                            children: [
                                                "In case, I decide after the recorded session that I don’t want some specific information to be shared,",
                                                " ",
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("strong", {
                                                    children: [
                                                        "I express this clearly via e-mail to",
                                                        " ",
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                            href: "mailto:info@casehub.pro",
                                                            className: "link-primary",
                                                            children: "info@casehub.pro"
                                                        }),
                                                        " ",
                                                        "within 24 hours after the session."
                                                    ]
                                                }),
                                                " ",
                                                "I am aware of Casehub’s obligation not to use this information."
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(CodeOfConductSection, {
                                    title: "General",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_ui_typography__WEBPACK_IMPORTED_MODULE_2__/* .Typography */ .Z, {
                                            variant: "p",
                                            children: [
                                                "I will",
                                                " ",
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                                    children: "report any activity or contribution in Casehub that is unrespectful towards"
                                                }),
                                                " ",
                                                "any Member or organisation related to any Mamber by sending an e-mail with supporting evidence to",
                                                " ",
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                    href: "mailto:info@casehub.pro",
                                                    className: "link-primary",
                                                    children: "info@casehub.pro"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_ui_typography__WEBPACK_IMPORTED_MODULE_2__/* .Typography */ .Z, {
                                            variant: "p",
                                            children: [
                                                "I am aware that ",
                                                " ",
                                                " ",
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                                    children: "Casehub has a right to block the account of the member"
                                                }),
                                                " ",
                                                "who have violated the Casehub’s ",
                                                " ",
                                                " ",
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                    href: "/content/terms",
                                                    target: "_blank",
                                                    rel: "nofollow noopener",
                                                    className: "link-primary",
                                                    children: "Terms of Use"
                                                }),
                                                " or the Code of Conduct."
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_dialog__WEBPACK_IMPORTED_MODULE_3__/* .DialogFooter */ .cN, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_button__WEBPACK_IMPORTED_MODULE_4__/* .Button */ .z, {
                        type: "button",
                        onClick: function() {
                            onOpenChange(false);
                        },
                        children: "Close"
                    })
                })
            ]
        })
    });
};
var CodeOfConductSection = function(param) {
    var children = param.children, title = param.title;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "p-4",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_typography__WEBPACK_IMPORTED_MODULE_2__/* .Typography */ .Z, {
                variant: "h5",
                className: "mb-2",
                children: title
            }),
            children
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CodeOfConductModal);


/***/ }),

/***/ 70822:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ RecaptchaComponent; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(28668);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(91224);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react_google_recaptcha_v3__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50259);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);







var RecaptchaComponent = function(Component) {
    var Recaptcha = function(param) {
        var children = param.children;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_google_recaptcha_v3__WEBPACK_IMPORTED_MODULE_1__/* .GoogleReCaptchaProvider */ .pm, {
            reCaptchaKey: "6LdNROIbAAAAAPoPSHLNgn47Uv66BAqgvjkdQn4-" || 0,
            children: children
        });
    };
    return /*#__PURE__*/ function(_Component) {
        "use strict";
        (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(Higher, _Component);
        var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(Higher);
        function Higher() {
            (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(this, Higher);
            return _super.apply(this, arguments);
        }
        var _proto = Higher.prototype;
        _proto.render = function render() {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Recaptcha, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Component, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, this.props))
            });
        };
        return Higher;
    }(react__WEBPACK_IMPORTED_MODULE_2__.Component);
};


/***/ }),

/***/ 47460:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);



var SeoTags = function(props) {
    if (!(props === null || props === void 0 ? void 0 : props.config)) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: [
            props.config.title ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: props.config.title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:title",
                        content: props.config.title
                    })
                ]
            }) : null,
            props.config.description ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: props.config.description
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:description",
                        content: props.config.description
                    })
                ]
            }) : null,
            props.config.keywords ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "keywords",
                content: props.config.keywords
            }) : null,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                content: "//casehub.pro/og.png"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SeoTags);


/***/ }),

/***/ 5138:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ SignUpForm; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(828);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_ui_input__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72685);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var zod__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1604);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(87536);
/* harmony import */ var _hookform_resolvers_zod__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(56312);
/* harmony import */ var _components_ui_form__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(27946);
/* harmony import */ var _util_hooks_useLocalStorage__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(61959);











var formSchema = zod__WEBPACK_IMPORTED_MODULE_5__/* .object */ .Ry({
    firstName: zod__WEBPACK_IMPORTED_MODULE_5__/* .string */ .Z_({
        required_error: "Please enter your first name"
    }),
    lastName: zod__WEBPACK_IMPORTED_MODULE_5__/* .string */ .Z_({
        required_error: "Please enter your last name"
    }),
    email: zod__WEBPACK_IMPORTED_MODULE_5__/* .string */ .Z_({
        required_error: "Please enter an email"
    }).min(1, {
        message: "This field has to be filled."
    }).email("This is not a valid email."),
    password: zod__WEBPACK_IMPORTED_MODULE_5__/* .string */ .Z_({
        required_error: "You must specify a password"
    }).min(8, {
        message: "Password must have at least 8 characters"
    }),
    referrer: zod__WEBPACK_IMPORTED_MODULE_5__/* .string */ .Z_().optional()
});
var SignUpForm = function(props) {
    var form = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_6__/* .useForm */ .cI)({
        resolver: (0,_hookform_resolvers_zod__WEBPACK_IMPORTED_MODULE_7__/* .zodResolver */ .F)(formSchema)
    });
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_util_hooks_useLocalStorage__WEBPACK_IMPORTED_MODULE_4__/* .useLocalStorage */ ._)("r", null), 3), referral = ref[0], clearReferral = ref[2];
    var onSubmit = function(values) {
        if (typeof props.onSubmit === "function") {
            props.onSubmit(values);
            if (referral === null || referral === void 0 ? void 0 : referral.key) {
                clearReferral();
            }
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_form__WEBPACK_IMPORTED_MODULE_3__/* .Form */ .l0, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, form), {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("form", {
                onSubmit: form.handleSubmit(onSubmit),
                className: "space-y-4",
                id: props.formId,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "grid grid-cols-1 md:grid-cols-2 gap-4",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_form__WEBPACK_IMPORTED_MODULE_3__/* .FormField */ .Wi, {
                                control: form.control,
                                name: "firstName",
                                render: function(param) {
                                    var field = param.field;
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_ui_form__WEBPACK_IMPORTED_MODULE_3__/* .FormItem */ .xJ, {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_form__WEBPACK_IMPORTED_MODULE_3__/* .FormLabel */ .lX, {
                                                children: "First name"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_form__WEBPACK_IMPORTED_MODULE_3__/* .FormControl */ .NI, {
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_input__WEBPACK_IMPORTED_MODULE_1__/* .Input */ .I, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({
                                                    placeholder: "ex. John"
                                                }, field))
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_form__WEBPACK_IMPORTED_MODULE_3__/* .FormMessage */ .zG, {})
                                        ]
                                    });
                                }
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_form__WEBPACK_IMPORTED_MODULE_3__/* .FormField */ .Wi, {
                                control: form.control,
                                name: "lastName",
                                render: function(param) {
                                    var field = param.field;
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_ui_form__WEBPACK_IMPORTED_MODULE_3__/* .FormItem */ .xJ, {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_form__WEBPACK_IMPORTED_MODULE_3__/* .FormLabel */ .lX, {
                                                children: "Last name"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_form__WEBPACK_IMPORTED_MODULE_3__/* .FormControl */ .NI, {
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_input__WEBPACK_IMPORTED_MODULE_1__/* .Input */ .I, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({
                                                    placeholder: "ex. Doe"
                                                }, field))
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_form__WEBPACK_IMPORTED_MODULE_3__/* .FormMessage */ .zG, {})
                                        ]
                                    });
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_form__WEBPACK_IMPORTED_MODULE_3__/* .FormField */ .Wi, {
                        control: form.control,
                        name: "email",
                        render: function(param) {
                            var field = param.field;
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_ui_form__WEBPACK_IMPORTED_MODULE_3__/* .FormItem */ .xJ, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_form__WEBPACK_IMPORTED_MODULE_3__/* .FormLabel */ .lX, {
                                        children: "E-mail"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_form__WEBPACK_IMPORTED_MODULE_3__/* .FormControl */ .NI, {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_input__WEBPACK_IMPORTED_MODULE_1__/* .Input */ .I, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({
                                            placeholder: "ex. johndoe@gmail.com"
                                        }, field))
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_form__WEBPACK_IMPORTED_MODULE_3__/* .FormMessage */ .zG, {})
                                ]
                            });
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_form__WEBPACK_IMPORTED_MODULE_3__/* .FormField */ .Wi, {
                        control: form.control,
                        name: "password",
                        render: function(param) {
                            var field = param.field;
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_ui_form__WEBPACK_IMPORTED_MODULE_3__/* .FormItem */ .xJ, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_form__WEBPACK_IMPORTED_MODULE_3__/* .FormLabel */ .lX, {
                                        children: "Password"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_form__WEBPACK_IMPORTED_MODULE_3__/* .FormControl */ .NI, {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_input__WEBPACK_IMPORTED_MODULE_1__/* .Input */ .I, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({
                                            type: "password",
                                            autoComplete: "new-password"
                                        }, field))
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_form__WEBPACK_IMPORTED_MODULE_3__/* .FormMessage */ .zG, {})
                                ]
                            });
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({
                        type: "hidden",
                        value: (referral === null || referral === void 0 ? void 0 : referral.key) || ""
                    }, form.register("referrer")))
                ]
            })
        }))
    });
};


/***/ }),

/***/ 64345:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ol": function() { return /* binding */ CardHeader; },
/* harmony export */   "SZ": function() { return /* binding */ CardDescription; },
/* harmony export */   "Zb": function() { return /* binding */ Card; },
/* harmony export */   "aY": function() { return /* binding */ CardContent; },
/* harmony export */   "eW": function() { return /* binding */ CardFooter; },
/* harmony export */   "ll": function() { return /* binding */ CardTitle; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _lib_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(74183);





var Card = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function(_param, ref) /*#__PURE__*/ {
    var className = _param.className, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "className"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        ref: ref,
        className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_4__.cn)("rounded-lg border bg-card text-card-foreground shadow-sm", className)
    }, props));
});
Card.displayName = "Card";
var CardHeader = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function(_param, ref) /*#__PURE__*/ {
    var className = _param.className, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "className"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        ref: ref,
        className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_4__.cn)("flex flex-col space-y-1.5 p-6", className)
    }, props));
});
CardHeader.displayName = "CardHeader";
var CardTitle = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function(_param, ref) /*#__PURE__*/ {
    var className = _param.className, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "className"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        ref: ref,
        className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_4__.cn)("text-2xl font-semibold leading-none tracking-tight", className)
    }, props));
});
CardTitle.displayName = "CardTitle";
var CardDescription = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function(_param, ref) /*#__PURE__*/ {
    var className = _param.className, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "className"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        ref: ref,
        className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_4__.cn)("text-sm text-muted-foreground", className)
    }, props));
});
CardDescription.displayName = "CardDescription";
var CardContent = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function(_param, ref) /*#__PURE__*/ {
    var className = _param.className, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "className"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        ref: ref,
        className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_4__.cn)("p-6 pt-0", className)
    }, props));
});
CardContent.displayName = "CardContent";
var CardFooter = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function(_param, ref) /*#__PURE__*/ {
    var className = _param.className, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "className"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        ref: ref,
        className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_4__.cn)(" flex items-center p-6 pt-0", className)
    }, props));
});
CardFooter.displayName = "CardFooter";



/***/ }),

/***/ 70499:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$N": function() { return /* binding */ DialogTitle; },
/* harmony export */   "Be": function() { return /* binding */ DialogDescription; },
/* harmony export */   "GG": function() { return /* binding */ DialogClose; },
/* harmony export */   "Vq": function() { return /* binding */ Dialog; },
/* harmony export */   "cN": function() { return /* binding */ DialogFooter; },
/* harmony export */   "cZ": function() { return /* binding */ DialogContent; },
/* harmony export */   "fK": function() { return /* binding */ DialogHeader; },
/* harmony export */   "hg": function() { return /* binding */ DialogTrigger; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _radix_ui_react_dialog__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12854);
/* harmony import */ var lucide_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(41352);
/* harmony import */ var _lib_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(74183);
"use client";








var Dialog = _radix_ui_react_dialog__WEBPACK_IMPORTED_MODULE_2__/* .Root */ .fC;
var DialogTrigger = _radix_ui_react_dialog__WEBPACK_IMPORTED_MODULE_2__/* .Trigger */ .xz;
var DialogClose = _radix_ui_react_dialog__WEBPACK_IMPORTED_MODULE_2__/* .Close */ .x8;
var DialogPortal = function(_param) /*#__PURE__*/ {
    var className = _param.className, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "className"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_dialog__WEBPACK_IMPORTED_MODULE_2__/* .Portal */ .h_, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_5__.cn)(className)
    }, props));
};
DialogPortal.displayName = _radix_ui_react_dialog__WEBPACK_IMPORTED_MODULE_2__/* .Portal.displayName */ .h_.displayName;
var DialogOverlay = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function(_param, ref) /*#__PURE__*/ {
    var className = _param.className, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "className"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_dialog__WEBPACK_IMPORTED_MODULE_2__/* .Overlay */ .aV, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        ref: ref,
        className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_5__.cn)("fixed inset-0 z-50 bg-background/80 backdrop-blur-sm data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0", className)
    }, props));
});
DialogOverlay.displayName = _radix_ui_react_dialog__WEBPACK_IMPORTED_MODULE_2__/* .Overlay.displayName */ .aV.displayName;
var DialogContent = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function(_param, ref) /*#__PURE__*/ {
    var className = _param.className, children = _param.children, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "className",
        "children"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(DialogPortal, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DialogOverlay, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_radix_ui_react_dialog__WEBPACK_IMPORTED_MODULE_2__/* .Content */ .VY, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                ref: ref,
                className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_5__.cn)("fixed left-[50%] top-[50%] z-50 grid w-full max-w-lg translate-x-[-50%] translate-y-[-50%] gap-4 border bg-background p-6 shadow-lg duration-200 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%] data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%] sm:rounded-lg md:w-full", className)
            }, props), {
                children: [
                    children,
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_radix_ui_react_dialog__WEBPACK_IMPORTED_MODULE_2__/* .Close */ .x8, {
                        className: "absolute right-4 top-4 rounded-sm opacity-70 ring-offset-background transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:pointer-events-none data-[state=open]:bg-accent data-[state=open]:text-muted-foreground",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(lucide_react__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                className: "h-4 w-4"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "sr-only",
                                children: "Close"
                            })
                        ]
                    })
                ]
            }))
        ]
    });
});
DialogContent.displayName = _radix_ui_react_dialog__WEBPACK_IMPORTED_MODULE_2__/* .Content.displayName */ .VY.displayName;
var DialogHeader = function(_param) /*#__PURE__*/ {
    var className = _param.className, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "className"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_5__.cn)("flex flex-col space-y-1.5 text-center sm:text-left", className)
    }, props));
};
DialogHeader.displayName = "DialogHeader";
var DialogFooter = function(_param) /*#__PURE__*/ {
    var className = _param.className, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "className"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_5__.cn)("flex flex-col-reverse sm:flex-row sm:justify-end sm:space-x-2", className)
    }, props));
};
DialogFooter.displayName = "DialogFooter";
var DialogTitle = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function(_param, ref) /*#__PURE__*/ {
    var className = _param.className, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "className"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_dialog__WEBPACK_IMPORTED_MODULE_2__/* .Title */ .Dx, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        ref: ref,
        className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_5__.cn)("text-lg font-semibold leading-none tracking-tight", className)
    }, props));
});
DialogTitle.displayName = _radix_ui_react_dialog__WEBPACK_IMPORTED_MODULE_2__/* .Title.displayName */ .Dx.displayName;
var DialogDescription = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function(_param, ref) /*#__PURE__*/ {
    var className = _param.className, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "className"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_dialog__WEBPACK_IMPORTED_MODULE_2__/* .Description */ .dk, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        ref: ref,
        className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_5__.cn)("text-sm text-muted-foreground", className)
    }, props));
});
DialogDescription.displayName = _radix_ui_react_dialog__WEBPACK_IMPORTED_MODULE_2__/* .Description.displayName */ .dk.displayName;



/***/ }),

/***/ 27946:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "NI": function() { return /* binding */ FormControl; },
/* harmony export */   "Wi": function() { return /* binding */ FormField; },
/* harmony export */   "l0": function() { return /* binding */ Form; },
/* harmony export */   "lX": function() { return /* binding */ FormLabel; },
/* harmony export */   "pf": function() { return /* binding */ FormDescription; },
/* harmony export */   "xJ": function() { return /* binding */ FormItem; },
/* harmony export */   "zG": function() { return /* binding */ FormMessage; }
/* harmony export */ });
/* unused harmony export useFormField */
/* harmony import */ var _swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(40872);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _radix_ui_react_slot__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(88426);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87536);
/* harmony import */ var _lib_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(74183);
/* harmony import */ var _components_ui_label__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93223);










var Form = react_hook_form__WEBPACK_IMPORTED_MODULE_3__/* .FormProvider */ .RV;
var FormFieldContext = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createContext({});
var FormField = function(_param) {
    var props = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FormFieldContext.Provider, {
        value: {
            name: props.name
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_hook_form__WEBPACK_IMPORTED_MODULE_3__/* .Controller */ .Qr, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, props))
    });
};
var useFormField = function() {
    var fieldContext = react__WEBPACK_IMPORTED_MODULE_1__.useContext(FormFieldContext);
    var itemContext = react__WEBPACK_IMPORTED_MODULE_1__.useContext(FormItemContext);
    var ref = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_3__/* .useFormContext */ .Gc)(), getFieldState = ref.getFieldState, formState = ref.formState;
    var fieldState = getFieldState(fieldContext.name, formState);
    if (!fieldContext) {
        throw new Error("useFormField should be used within <FormField>");
    }
    var id = itemContext.id;
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        id: id,
        name: fieldContext.name,
        formItemId: "".concat(id, "-form-item"),
        formDescriptionId: "".concat(id, "-form-item-description"),
        formMessageId: "".concat(id, "-form-item-message")
    }, fieldState);
};
var FormItemContext = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createContext({});
var FormItem = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function(_param, ref) {
    var className = _param.className, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_param, [
        "className"
    ]);
    var id = react__WEBPACK_IMPORTED_MODULE_1__.useId();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FormItemContext.Provider, {
        value: {
            id: id
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
            ref: ref,
            className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_7__.cn)("space-y-2", className)
        }, props))
    });
});
FormItem.displayName = "FormItem";
var FormLabel = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function(_param, ref) {
    var className = _param.className, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_param, [
        "className"
    ]);
    var _$ref = useFormField(), error = _$ref.error, formItemId = _$ref.formItemId;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_label__WEBPACK_IMPORTED_MODULE_2__/* .Label */ ._, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        ref: ref,
        className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_7__.cn)(error && "text-destructive", className),
        htmlFor: formItemId
    }, props));
});
FormLabel.displayName = "FormLabel";
var FormControl = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function(_param, ref) {
    var props = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
    var _$ref = useFormField(), error = _$ref.error, formItemId = _$ref.formItemId, formDescriptionId = _$ref.formDescriptionId, formMessageId = _$ref.formMessageId;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_slot__WEBPACK_IMPORTED_MODULE_8__/* .Slot */ .g7, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        ref: ref,
        id: formItemId,
        "aria-describedby": !error ? "".concat(formDescriptionId) : "".concat(formDescriptionId, " ").concat(formMessageId),
        "aria-invalid": !!error
    }, props));
});
FormControl.displayName = "FormControl";
var FormDescription = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function(_param, ref) {
    var className = _param.className, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_param, [
        "className"
    ]);
    var formDescriptionId = useFormField().formDescriptionId;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        ref: ref,
        id: formDescriptionId,
        className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_7__.cn)("text-sm text-muted-foreground", className)
    }, props));
});
FormDescription.displayName = "FormDescription";
var FormMessage = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function(_param, ref) {
    var className = _param.className, children = _param.children, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_param, [
        "className",
        "children"
    ]);
    var _$ref = useFormField(), error = _$ref.error, formMessageId = _$ref.formMessageId;
    var body = error ? String(error === null || error === void 0 ? void 0 : error.message) : children;
    if (!body) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        ref: ref,
        id: formMessageId,
        className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_7__.cn)("text-sm font-medium text-destructive", className)
    }, props), {
        children: body
    }));
});
FormMessage.displayName = "FormMessage";



/***/ }),

/***/ 72685:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ Input; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(828);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _lib_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(74183);
/* harmony import */ var _components_icons__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(43936);







var Input = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function(_param, ref) {
    var className = _param.className, type = _param.type, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "className",
        "type"
    ]);
    var _$ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_1__.useState(false), 2), showPassword = _$ref[0], setShowPassword = _$ref[1];
    var togglePasswordVisibility = function() {
        setShowPassword(!showPassword);
    };
    var inputType = type === "password" && showPassword ? "text" : type;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "relative",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                type: inputType,
                className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_6__.cn)("flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 pr-10", className),
                ref: ref
            }, props)),
            type === "password" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                type: "button",
                className: "absolute right-3 top-1/2 -translate-y-1/2",
                onClick: togglePasswordVisibility,
                children: showPassword ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_icons__WEBPACK_IMPORTED_MODULE_2__/* .Icons.eye */ .P.eye, {
                    className: "h-4 w-4 text-gray-500"
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_icons__WEBPACK_IMPORTED_MODULE_2__/* .Icons.eyeOff */ .P.eyeOff, {
                    className: "h-4 w-4 text-gray-500"
                })
            })
        ]
    });
});
Input.displayName = "Input";



/***/ }),

/***/ 93223:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ Label; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _radix_ui_react_label__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(49102);
/* harmony import */ var class_variance_authority__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12003);
/* harmony import */ var _lib_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(74183);
"use client";







var labelVariants = (0,class_variance_authority__WEBPACK_IMPORTED_MODULE_2__/* .cva */ .j)("text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70");
var Label = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function(_param, ref) /*#__PURE__*/ {
    var className = _param.className, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "className"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_label__WEBPACK_IMPORTED_MODULE_4__/* .Root */ .f, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        ref: ref,
        className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_6__.cn)(labelVariants(), className)
    }, props));
});
Label.displayName = _radix_ui_react_label__WEBPACK_IMPORTED_MODULE_4__/* .Root.displayName */ .f.displayName;



/***/ }),

/***/ 58020:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Typography; }
/* harmony export */ });
/* unused harmony export typographyVariants */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var class_variance_authority__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12003);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _radix_ui_react_slot__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(88426);
/* harmony import */ var _lib_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(74183);







var typographyVariants = (0,class_variance_authority__WEBPACK_IMPORTED_MODULE_2__/* .cva */ .j)("", {
    variants: {
        variant: {
            default: "",
            h1: "scroll-m-20 text-4xl font-extrabold tracking-tight lg:text-5xl",
            h2: "scroll-m-20 pb-2 text-3xl font-semibold tracking-tight transition-colors first:mt-0",
            h3: "scroll-m-20 text-2xl font-semibold tracking-tight",
            h4: "scroll-m-20 text-xl font-semibold tracking-tight",
            h5: "scroll-m-20 text-lg font-semibold tracking-tight",
            h6: "scroll-m-20 text-sm font-semibold tracking-tight",
            p: "leading-7 [&:not(:first-child)]:mt-6",
            blockquote: "mt-6 border-l-2 pl-6 italic",
            lead: "text-xl text-muted-foreground",
            large: "text-lg font-semibold",
            small: "text-sm font-medium leading-none",
            muted: "text-xs text-muted-foreground",
            xs: "text-xs font-medium leading-none"
        }
    },
    defaultVariants: {
        variant: "default"
    }
});
var Typography = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function(_param, ref) {
    var className = _param.className, variant = _param.variant, _asChild = _param.asChild, asChild = _asChild === void 0 ? false : _asChild, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "className",
        "variant",
        "asChild"
    ]);
    var Comp = asChild ? _radix_ui_react_slot__WEBPACK_IMPORTED_MODULE_4__/* .Slot */ .g7 : "p";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Comp, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_6__.cn)(typographyVariants({
            variant: variant,
            className: className
        })),
        ref: ref
    }, props));
});
Typography.displayName = "Typography";



/***/ }),

/***/ 74802:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ events; },
/* harmony export */   "x": function() { return /* binding */ addGtmEvent; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(69396);


function addGtmEvent(eventName, eventProps) {
    if (true) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, eventProps), {
            event: eventName
        }));
    }
}
var events = {
    verificationComplete: "verificationComplete",
    registration: "registration",
    login: "login"
};


/***/ }),

/***/ 38625:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ useAssessmentFormStorage; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(828);
/* harmony import */ var _useLocalStorage__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61959);
/* harmony import */ var _auth__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19475);



var useAssessmentFormStorage = function(key) {
    var ref;
    var auth = (0,_auth__WEBPACK_IMPORTED_MODULE_1__/* .useAuth */ .aC)();
    var userKey = (auth === null || auth === void 0 ? void 0 : (ref = auth.user) === null || ref === void 0 ? void 0 : ref.id) || 0;
    var storageKey = "assessment-form-".concat(key ? "".concat(key, "-") : "").concat(userKey);
    var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_useLocalStorage__WEBPACK_IMPORTED_MODULE_0__/* .useLocalStorage */ ._)(storageKey, {}), 3), answers = ref1[0], setAnswers = ref1[1], clearAnswers = ref1[2];
    return [
        answers,
        setAnswers,
        clearAnswers
    ];
};


/***/ }),

/***/ 61959:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ useLocalStorage; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82670);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _util_hooks_useStableCallback__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(80995);



function useLocalStorage(key, initialValue) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(function() {
        try {
            var item = window.localStorage.getItem(key);
            return item ? JSON.parse(item) : initialValue;
        } catch (error) {
            return initialValue;
        }
    }), storedValue = ref[0], setStoredValue = ref[1];
    var setValue = (0,_util_hooks_useStableCallback__WEBPACK_IMPORTED_MODULE_1__/* .useStableCallback */ .R)(function(value) {
        try {
            var valueToStore = (0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(value, Function) ? value(storedValue) : value;
            setStoredValue(valueToStore);
            window.localStorage.setItem(key, JSON.stringify(valueToStore));
        } catch (error) {}
    });
    var removeValue = (0,_util_hooks_useStableCallback__WEBPACK_IMPORTED_MODULE_1__/* .useStableCallback */ .R)(function() {
        try {
            window.localStorage.removeItem(key);
            setStoredValue(initialValue);
        } catch (error) {}
    });
    return [
        storedValue,
        setValue,
        removeValue
    ];
}


/***/ })

}]);